import { observer } from 'mobx-react-lite';
import React, { useEffect, useState } from 'react';
import { loadResources } from '../../../core/helpers/loadResources';
import { initialGameResources } from '../../../core/resources';
import { iframeService } from '../../../services/iframeService';
import GameStage from '../gameStage';

const Game = observer(() => {
  const [isInitialResourceLoaded, setIsInitialResourceLoaded] = useState(false);

  useEffect(() => {
    loadResources([...initialGameResources]).then(() => {
      setIsInitialResourceLoaded(true);
      iframeService.sendLoadedState();
    });
  }, []);

  if (!isInitialResourceLoaded) {
    return null;
  }
  return <GameStage />;
});

export default Game;
